import { render } from "./RefundPolicy.vue?vue&type=template&id=7969d598&scoped=true"
const script = {}

import "./RefundPolicy.vue?vue&type=style&index=0&id=7969d598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7969d598"]])

export default __exports__